import { render } from "./MedalRow.vue?vue&type=template&id=47313d2a&scoped=true"
import script from "./MedalRow.vue?vue&type=script&lang=js"
export * from "./MedalRow.vue?vue&type=script&lang=js"

import "./MedalRow.vue?vue&type=style&index=0&id=47313d2a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47313d2a"]])

export default __exports__